/*
/	Corentin BOUTON — Junior Mines Provence 2023
/	contact@junior-mines-provence.fr
/	https://junior-mines-provence.fr
*/

import { useState } from 'react';
import { Button } from 'react-bootstrap';

import { Item } from '../Fonctions';
import ModalDevis from './ModalDevis';

function BoutonDevis({ isPortrait, store_type, commande, compas, securite, largeur, hauteur, couleur, environnement, computeenv, HorsNormes, prix, orientation}) {
	const [modalShow, setModalShow] = useState(false);

	let size;
	isPortrait ? size = 'sm' : size = 'lg';

	return (
		<>
			<Button onClick={() => setModalShow(true)} size={size} variant='outline-dark'><Item>Valider ma configuration</Item></Button>
			<ModalDevis
			show={modalShow}
			onHide={() => setModalShow(false)}
			store_type={store_type}
			commande={commande}
			compas={compas}
			securite={securite}
			largeur={largeur}
			hauteur={hauteur}
			couleur={couleur}
			environnement={environnement}
			computeenv={computeenv}
			HorsNormes={HorsNormes}
			prix={prix}
			orientation={orientation}
			/>
		</>
	);
}

export default BoutonDevis;
